import Vue from 'vue';
import Vuex, { StoreOptions } from 'vuex';
import { RootState } from './types';
import { signup } from './modules/signup';
import { offer } from './modules/offer';
import { business } from './modules/business';
import { billing } from './modules/billing';
import { flags } from './modules/flags';
import { abTests } from './modules/abTests';
import { modal } from './modules/modal';
import { stripe } from './modules/stripe';
import { manager } from './modules/manager';
import { merchant } from './modules/merchant';
import { registration } from './modules/registration';
import { internationalization } from './modules/internationalization';
import { socialRewards } from './modules/socialRewards';
import { businessOnboarding } from './modules/businessOnboarding';
import { startGuide } from './modules/startGuide';
import { rewardsProgram } from './modules/rewardsProgram';
import { performance } from './modules/performance';
import { offerList } from './modules/offerList';
import Module from './interfaces/module.interface';

Vue.use(Vuex);

export const modules: { [k: string]: Module<any, RootState> } = {
  flags,
  abTests,
  modal,
  business,
  billing,
  internationalization,
  offer,
  signup,
  stripe,
  manager,
  merchant,
  registration,
  socialRewards,
  businessOnboarding,
  startGuide,
  rewardsProgram,
  performance,
  offerList
};

const store: StoreOptions<RootState> = {
  state: {
    version: '1.0.0'
  },
  modules
};

export default new Vuex.Store<RootState>(store);
